/* eslint-disable @typescript-eslint/no-explicit-any */
import { GRADIENT_TITLE, JOIN_NOW_BG, JOIN_NOW_BLOCK, JOIN_NOW_BTN_BG, OPEN_RACE_BG, BTN_RECORD } from 'assets/images'
import styled from 'styled-components'

const streamTitleDimensionRatio = 3.84

const StyledHome = styled.div`
  .view-btn {
    text-decoration: none;

    span {
      font-size: 18px;
    }

    img {
      width: 11px;
      height: 8px;
      object-fit: contain;
      margin-left: 4px;
    }
  }
  .banner-meta {
    .icon-meta {
      opacity: 0.4;
    }
    .icon-horse {
      margin-left: -65px;
      opacity: 0.4;
    }
    .active {
      opacity: 1;
      filter: brightness(5);
    }
  }
  .banner {
    margin-top: 47px;

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      margin-bottom: 20px;
    }

    .logo-banner {
      ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
        width: 610px;
      }

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        width: 100%;
      }
    }

    .hero-panel {
      position: relative;
      width: 100%;
      padding: 20px;
      overflow: hidden;
      background: radial-gradient(at 50% 0%, rgba(0, 255, 255, 0.05) 0%, transparent 60%), radial-gradient(at 50% 100%, rgba(120, 0, 255, 0.04) 0%, transparent 60%), linear-gradient(rgba(28, 43, 43, 0.95) 0%, rgb(29 45 52 / 98%) 100%);
      border: 1px solid rgba(0, 255, 255, 0.15);
      clip-path: polygon(
        20px 0%, calc(100% - 20px) 0%, 100% 20px, 100% calc(100% - 20px),
        calc(100% - 20px) 100%, 20px 100%, 0% calc(100% - 20px), 0% 20px
      );
      text-align: center;
      ${({ theme }) => theme.media.lessThan(theme.size.md)} {
        padding: 40px 20px;
      }

      /* Neon corner brackets */
      .hero-corner {
        position: absolute;
        width: 40px;
        height: 40px;
        border-color: #00ffb6;
        border-style: solid;
        z-index: 2;

        &--tl {
          top: 8px; left: 8px;
          border-width: 2px 0 0 2px;
        }
        &--tr {
          top: 8px; right: 8px;
          border-width: 2px 2px 0 0;
        }
        &--bl {
          bottom: 8px; left: 8px;
          border-width: 0 0 2px 2px;
        }
        &--br {
          bottom: 8px; right: 8px;
          border-width: 0 2px 2px 0;
        }
      }

      /* Grid pattern */
      .hero-grid-pattern {
        position: absolute;
        inset: 0;
        background-image:
          linear-gradient(rgba(0, 255, 255, 0.03) 1px, transparent 1px),
          linear-gradient(90deg, rgba(0, 255, 255, 0.03) 1px, transparent 1px);
        background-size: 40px 40px;
        pointer-events: none;
        z-index: 0;
      }

      /* Dual radial glow */
      .hero-glow {
        position: absolute;
        width: 300px;
        height: 300px;
        border-radius: 50%;
        filter: blur(80px);
        pointer-events: none;
        z-index: 0;

        &--left {
          top: -50px; left: -50px;
          background: rgba(0, 255, 255, 0.15);
        }
        &--right {
          bottom: -50px; right: -50px;
          background: #152a3c;
        }
      }

      /* Octagonal frame content */
      .hero-octagonal-frame {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
      }

      @keyframes heroPulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.4; transform: scale(0.7); }
      }

      /* Wordmark */
      .hero-wordmark {
        display: flex;
        align-items: center;
        gap: 16px;
        margin: 0;
        font-family: 'Orbitron', sans-serif;
        font-size: 96px;
        font-weight: 900;
        line-height: 1;
        background: linear-gradient(135deg, #00ffb6 0%, #7b2fff 50%, #00ffb6 100%);
        background-size: 200% 200%;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        animation: heroGradientShift 4s ease-in-out infinite;
        text-shadow: none;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          font-size: 60px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.md)} {
          font-size: 42px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          font-size: 28px;
          gap: 8px;
        }

        &__bracket {
          font-size: 0.5em;
          opacity: 0.7;
        }

        &__text {
          letter-spacing: 8px;

          ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
            letter-spacing: 3px;
          }
        }
      }

      @keyframes heroGradientShift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }

      /* Divider */
      .hero-divider {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 60%;
        max-width: 500px;

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          width: 80%;
        }

        &__line {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(8, 94, 79, 1), transparent);
        }

        &__diamond {
          color: #00ffb6;
          font-size: 10px;
        }
      }

      /* Tagline */
      .hero-tagline {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        letter-spacing: 1.5px;

        ${({ theme }) => theme.media.lessThan(theme.size.md)} {
          font-size: 14px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          font-size: 12px;
          letter-spacing: 0.5px;
        }

        &__accent {
          color: #46ffc6;
        }
      }

      /* Description */
      .hero-description {
        margin: 0;
        font-size: 16px;
        color: white;
        text-align: center;

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          font-size: 12px;
        }

        .highlight {
          color: #62e1ff;
          font-weight: 600;
        }
      }

      /* Badge pill row */
      .hero-badges {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
        margin-top: 4px;
        border: 1px solid #262e50;
        clip-path: polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%);
        background: #0b111f;

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 5px 14px;
          border-radius: 16px;
          font-size: 14px;
          color: white;
          white-space: nowrap;

          ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
            font-size: 10px;
            padding: 4px 10px;
          }
          .highlight {
            color: #00ffb6;
            font-weight: 600;
          }
          &__icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: rgba(0, 255, 182, 0.08);
            box-shadow:
              rgb(32 34 34 / 60%) 0px 0px 8px, rgb(112 126 121 / 35%) 1px 0px 8px, rgb(36 36 36 / 25%) 0px 0px 6px inset;
            font-size: 13px;
            line-height: 1;

            ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
              width: 18px;
              height: 18px;
              font-size: 10px;
            }
          }
          em {
            font-style: normal;
            color: #d3d3d3;
            font-size: 11px;
            ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
              font-size: 9px;
            }
          }
        }
      }

      /* Feature cards grid */
      .hero-features {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        width: 100%;
        margin-top: 12px;

        ${({ theme }) => theme.media.lessThan(theme.size.md)} {
          grid-template-columns: repeat(2, 1fr);
        }

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          grid-template-columns: 1fr;
        }
      }

      .hero-feature-card {
        background: rgba(6, 15, 35, 0.85);
        border: 1px solid rgba(38, 60, 90, 0.8);
        border-radius: 8px;
        padding: 14px 16px;
        text-align: left;
        transition: border-color 0.2s ease;

        &__header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
        }

        &__icon {
          font-size: 16px;
          line-height: 1;
        }

        &__title {
          flex: 1;
          font-size: 16px;
          font-weight: 700;
          color: #00e5ff;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        &__lock {
          display: inline-flex;
          align-items: center;
          gap: 3px;
          padding: 2px 8px;
          border-radius: 4px;
          border: 1px rgba(220, 38, 80, 0.85) solid;
          font-size: 10px;
          font-weight: 700;
          color: rgba(220, 38, 80, 0.85);
          letter-spacing: 0.5px;
          white-space: nowrap;
        }

        &__desc {
          margin: 0;
          font-size: 16px;
          color: #00e5ff;
          line-height: 1.5;
        }
      }
    }
  }
  .top-section {
    padding-top: 47px;
    column-gap: 20px;
    margin-bottom: 120px;

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      row-gap: 80px;
      margin-bottom: 80px;
    }
    .top-left {
      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        width: 100%;
      }

      .stream-title {
        background-image: url(${GRADIENT_TITLE});
        background-size: contain;
        background-repeat: no-repeat;
        bottom: 0px;
        left: 0;

        width: 170px;
        height: calc(190px / ${streamTitleDimensionRatio});

        text-transform: uppercase;
        font-size: 18px;

        ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
          width: 170px;
          height: calc(220px / ${streamTitleDimensionRatio});

          font-size: 18px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.md)} {
          width: 180px;
          height: calc(180px / ${streamTitleDimensionRatio});

          font-size: 16px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          width: 130px;
          height: calc(130px / ${streamTitleDimensionRatio});

          font-size: 12px;
        }

        span {
          top: 12px;
          left: 26px;

          ${({ theme }) => theme.media.lessThan(theme.size.md)} {
            top: 9px;
          }

          ${({ theme }) => theme.media.lessThan(theme.size.md)} {
            top: 7px;
            left: 18px;
          }
        }
      }

      .video-container {
        .video {
          .youtube-video {
            width: 100%;
            aspect-ratio: 867 / 554;
          }
        }
      }
    }

    .top-right {
      position: relative;
      bottom: 12px;

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        position: static;
        bottom: auto;
        width: 100%;
      }

      .head {
        .title {
          font-size: 24px;
          line-height: 20px;
        }
      }

      .content {
        min-height: 545px;
        min-width: 277px;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          row-gap: 36px;

          width: 100%;
          min-height: auto;
          min-width: auto;
        }

        .race-item {
          margin-bottom: 24px;

          ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
            margin-bottom: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }


      }
    }
  }

  .bg-fluid {
    background-image: url(${OPEN_RACE_BG});
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: 310px;

    ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
      background-position-y: 92%;
    }

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      background-image: none;
    }

    .open-race-section {
      margin-bottom: 130px;

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        margin-bottom: 80px;
      }

      .head {
        margin-bottom: 40px;

        ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
          margin-bottom: 14px;
        }

        .title {
          font-size: 36px;
          line-height: 26px;

          ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
            font-size: 24px;
            line-height: 20px;
          }
        }
      }

      .content {
        margin-bottom: 50px;
        min-height: 326px;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          row-gap: 24px;
        }
      }

      .class-category {
        column-gap: 10px;

        .arrow-left {
          cursor: pointer;
        }

        .arrow-right {
          cursor: pointer;
        }

        .category-content {
          column-gap: 12px;

          ${({ theme }) => theme.media.lessThan(theme.size.md)} {
            flex-wrap: wrap;
            row-gap: 12px;
          }
        }
      }
    }
  }

  .join-now-fluid-bg {
    background-image: url(${JOIN_NOW_BG});
    margin-bottom: 120px;

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      margin-bottom: 80px;
    }

    .container {
      padding: 60px 0;

      ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
        padding: 40px 0;
      }

      .join-now {
        background-image: url(${JOIN_NOW_BLOCK});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        padding: 60px 230px;

        ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
          padding: 20px 140px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          background-size: cover;
        }

        .content {
          .title {
            text-transform: uppercase;
            font-size: 44px;
            line-height: 52.8px;

            margin-bottom: 20px;

            ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
              font-size: 34px;
              margin-bottom: 6px;
            }

            ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
              font-size: 28px;
              line-height: 30px;
            }

            ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
              margin-bottom: 14px;
            }
          }

          .input-name {
            border: none;
            border-bottom: 1px solid ${({ theme }) => theme.color.white};
            background-color: ${({ theme }) => theme.color.transparent};

            font-size: 16px;
            line-height: 19.2px;

            width: 386px;
            margin-bottom: 28px;

            &:focus {
              outline: none;
            }

            ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
              width: 280px;
            }
          }

          .join-now-btn {
            background-color: ${({ theme }) => theme.color.transparent};
            border: none;
            background-image: url(${JOIN_NOW_BTN_BG});
            background-size: contain;
            background-repeat: no-repeat;

            margin-top: 20px;
            font-size: 24px;
            line-height: 28px;

            width: 172px;
            height: 50px;

            ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
              font-size: 20px;

              width: 150px;
              height: 44px;
            }

            ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
              font-size: 16px;

              width: 110px;
              height: 32px;
            }

            img {
              bottom: -1px;
              right: 23px;

              width: 21px;
              height: 6px;
              object-fit: contain;

              ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
                right: 19px;
              }

              ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
                right: 14px;

                width: 16px;
                height: 5px;
              }
            }
          }
        }

        .horse-place {
          .horse {
            bottom: 53px;
            right: 105px;

            width: 443px;
            height: 332px;
            object-fit: contain;

            ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
              bottom: 10px;
              width: 40%;
            }
          }

          .shadow {
            bottom: 46px;
            right: 20px;

            ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
              bottom: 22px;
              width: 40%;
            }
          }
        }
      }
    }
  }

  .top-horse-section {
    margin-bottom: 120px;

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      margin-bottom: 80px;
    }

    .top-horse {
      .top-horse-title {
        font-size: 36px;
        line-height: 26px;

        margin-bottom: 60px;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          font-size: 24px;
          margin-bottom: 30px;
        }
      }

      .content {
        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          row-gap: 46px;
        }
      }
    }
  }

  .top-stable-section {
    margin-bottom: 104px;

    ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
      margin-bottom: 80px;
    }

    .top-stable {
      .top-stable-title {
        font-size: 36px;
        line-height: 26px;

        margin-bottom: 30px;

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          font-size: 24px;
          margin-bottom: 30px;
        }
      }

      .content {
        ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
          row-gap: 46px;
        }
      }

      .new_record_contain {
        width: 100%;
        height: 200px;

        .img_banner {
          width: 100%;
          height: 100%;
          position: relative;
        }

        .click_here_for_details {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 20%);
          z-index: 1;
          color: #fff;
          font-size: 28px;
          font-weight: 600;
          text-transform: uppercase;
          padding: 25px 35px;
        }

        .button_box {
          position: absolute;
          top: 110px;
          left: 50%;
          transform: translate(-50%, 0%);
          font-size: 24px;
          font-weight: 600;
          text-transform: uppercase;
        }
      }
    }
  }

  .top-horse-head {
      position: relative;
      .view-all {
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        font-size: 18px;
        text-decoration: none;

        &:hover {
          color: #fff;
        }
      }

      img.link {
        width: 11px;
        height: 8px;
        object-fit: contain;
        margin-left: 4px;
      }
    }
`

export default StyledHome

interface ButtonStyleProps {
  width?: any,
  height?: any
}

export const ButtonStyled = styled.div<ButtonStyleProps>`
  cursor: pointer;
  column-gap: 8px;
  width: fit-content;
  .btn-container- {
    position: relative;
    &:hover {
      filter: brightness(1.5);
    }
    .background-btn {
    }
  }
  .btn-container-disable {
    position: relative;
    filter: brightness(0.5);
  }

  .ant-spin-dot-item {
    background-color: #4ef076 !important;
  }

  .btn-name {
    /* position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    font-size: 20px;
    color: white;
    width: 100%;
    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ height }) => height + 'px'};
    padding: 0 15px;
  }
  .background-btn {
    background: url(${BTN_RECORD});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    min-height: ${({ height }) => height + 'px'};
    min-width: ${({ width }) => width + 'px'};
  }
`
